import { db } from "../../../../dexie/db";
import { downloadDexieFile } from "../../../../utils/downloadDexieFile";

export const downLoadDexieBunkeringfile = async (id: number, fileName: string) => {
  const data = await db.bunkering.get(id);
  if (!data?.bunkeringFile) {
    alert("File does not exist.");
    return;
  }
  downloadDexieFile(fileName, data.bunkeringFile);
};
